import { CanActivateFn } from '@angular/router';
import { ClientFeatureWhitelistService } from '../services/client-feature-whitelist.service';
import { inject } from '@angular/core';
import { Store } from '@ngxs/store';
import { ClientSelectionState } from '../state/ClientSelectionState/ClientSelection.state';
import { map, mergeMap } from 'rxjs/operators';
import { ClientTimeOffRequestService } from '../services/time-off-request.service';

export const clientFeatureWhitelistGuard: CanActivateFn = (route, state) => {
  const data = route.data;
  if (data.featureKey != null) {
    const whitelistService: ClientFeatureWhitelistService = inject(ClientFeatureWhitelistService);
    const store: Store = inject(Store);
    return store.selectOnce(ClientSelectionState.clientCode).pipe(
      mergeMap(code => {
        return whitelistService.checkWhitelistForFeature(code, data.featureKey);
      })
    );
  } else {
    return true;
  }
};

export const canEnableTimeOffGuard: CanActivateFn = (route, state) => {
  const store: Store = inject(Store);
  const request: ClientTimeOffRequestService = inject(ClientTimeOffRequestService);
  return store.selectOnce(ClientSelectionState.clientCode).pipe(
    mergeMap(code => {
      return request.canEnable(code).pipe(map(result => result.Value));
    })
  );
};
